/**
 * Harness feature flag key registry.
 *
 * Add new flag keys here as they are created in the Harness console.
 * Naming convention: [teamIdentifier?]_[appName?]_[featureName]
 */
export const HARNESS_FLAGS = {
  ADA_ZERO_REPORT_USERS: 'cp_ada_zero_report_users',
  CP_DECAGON_CHAT: 'cp_decagon_chat',
  CANDIDATE_FACING_STATUS: 'candidate_facing_status',
  INSTANT_EXCEPTIONS_DEBUG_ENABLED: 'instant_exceptions_debug_enabled',
  PERSONAL_BANNER: 'personal_candidate_portal_banner',
  // EVERI-3908: forces the employment-document multidoc upload flow onto
  // the legacy (non-OCR) manual entry path.
  VERIFICATIONS_OCR_MANUAL_ENTRY: 'verifications_ocr_manual_entry',
  // EVERI-4005: shared key across monolith/apply/candidate-portal (apply MR !3003)
  VERIFICATIONS_MULTIDOC_CANDIDATE_DOC_CONTEXT:
    'verifications_multidoc_candidate_doc_context',
  // ECDEX-3368: sends every candidate login entry to the unified-login broker
  // instead of WorkOS/SSN/EU. Evaluated pre-auth with the anonymous key.
  UNIFIED_LOGIN: 'acdx_cp_unified_login',
  // ECDEX-3368: accepts an inbound broker session on load without sending
  // login to the broker. Evaluated pre-auth with the anonymous key.
  UNIFIED_LOGIN_SESSION_MGMT: 'acdx_cp_unified_login_session_mgmt',
  // ECDEX-1567: global switch shared with candidate-portal-bff; on lets the
  // portal exchange customer links and send candidate credentials. Evaluated
  // with BFF_HARDENING_KEY, not a user or account.
  BFF_HARDENING: 'cdx_candidate_portal_bff_hardening',
  // ECDEX-3740: report-view items (and so the report PDF, which renders the
  // same components) use the Mastodon component instead of the Bootstrap
  // markup. Account traffic type: evaluated with the report's account id as
  // the key, in the browser and on the server, so an account can opt out and
  // the report and its PDF always agree.
  MASTODON_REPORT: 'cdx_cp_mastodon_report',
  // ECDEX-3961 (INC-12060): when a Filestack upload finishes without a url,
  // report it to Sentry and delete by handle instead of posting an empty
  // /delete_file. Account traffic type: keyed on the upload's account id
  // (report page, else verification), so it can ramp by account. Off, or
  // with no account id, the upload flows behave as before. Instant
  // exceptions has no account id and is not covered.
  FILESTACK_MISSING_URL_GUARD: 'cdx_cp_filestack_missing_url_guard',
} as const;

export const BFF_HARDENING_KEY = 'candidate-portal-bff';
